// extracted by mini-css-extract-plugin
module.exports = {"DiptychOrTriptych":"styles_DiptychOrTriptych__qz3kG","item":"styles_item__RHWpt","diptych":"styles_diptych__yoxTF","triptych":"styles_triptych__On57B"};